<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Mentee's Assessment</h3>
          </div>
          <div class="heading-seperator"></div>

          <div class="col-md-6 col-sm-9 col-12 mx-auto" style="font-size: 18px;">
            <label class="text-align-center">Mentees: </label>
            <hr style="width:100%;">
            <b-form-select v-model="mentees_selected" :options="mentees" style="margin-bottom: 10px !important" class="col-12" @change="updateMenteeTasklistAction()" />
          </div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <ul v-if="tasklists.length > 0">
            <li style="cursor: pointer" v-for="tasklist in tasklists" @click="displayTaskList(tasklist.id)">
              <div class="col-11 float-left font-15">{{ tasklist.name }}</div>
              <div class="col-1 float-left override-padding fa fa-angle-right" style="font-size: 20px !important;">&nbsp;</div>
            </li>
          </ul>
          <ul v-else>
            <li v-if="loading == false" style="border: 0;" class="noitems-custom-msg">
              No tasklist assigned for this mentee
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store.js';

export default {
        data() {
          return {
            task_id: '',
            mentees_id: 1,
            mentees_selected: '',
            mentees: [],
            tasklists: [],
            loading: false,
          }
        },
        components: {
          UserMenu,
          GoBack
        },
        methods: {
          showTasks(mentee_id) {
            axios.get('/desktop/mentees_tasklists', {
              params: {
                mentee_id: mentee_id,
                account_id: this.$store.state.user_accountid
              }
            })
            .then(response =>  {
              this.loading = false;
              this.tasklists = response.data;
            })
            .catch(function(error) {
              console.log(error);
            });
          },
          getMenteesAction() {
            axios.get('/mentees', {

            })
            .then(response =>  {
              this.mentees = response.data;
              this.mentees_selected = response.data[0].value;
              this.loading = true;
              this.tasklists = [];
              this.showTasks(this.mentees_selected);
            })
            .catch(function(error) {
              console.log(error);
            });
          },
          updateMenteeTasklistAction: function() {
            this.loading = true;
            this.tasklists = [];
            this.showTasks(this.mentees_selected);
          },
          displayTaskList(task_id) {
            var id = this.mentees_selected;
            this.navigate("/mentees-tasks-detail/" + id + "/" + task_id);
          },
          navigate(path) {
        	  router.push(path);
        	},
        },
        created: function () {
          this.getMenteesAction();
        }
    }

</script>

<style scoped>
  .back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
  }
  .mentee_name {
      font-size: 20px;
      margin-bottom: 0px;
  }
  hr {
    margin: 10px auto;
  }
  .container-wrapper ul {
    list-style: none;
    padding: 0px;
  }
  .container-wrapper ul li {
    padding: 10px 5px;
    border: 1px solid #CCC;
    margin-top: 10px;
    float: left;
    width: 100%;
  }
  label {
    width: 100%;
    font-size: 15px;
  }
  .custom-select {
    font-size: 14px;
    height: 38px;
  }


</style>



// WEBPACK FOOTER //
// src/components/mentor/mentees_tasks_list.vue